<script setup>
import { __ } from '@/utils'
import { ref } from 'vue';

const mobileOpen = ref(false);

const links = [
    {
        label: __('main'),
        icon: theme_path.url + '/resources/images/svg/icon-pie-chart.svg',
        url: '/'
    },
    {
        label: __('my account'),
        icon: theme_path.url + '/resources/images/svg/icon-user.svg',
        url: '/profile'
    },
    {
        label: __('Details of uses'),
        icon: theme_path.url + '/resources/images/svg/icon-stats.svg',
        url: '/usages'
    },
    {
        label: __('Invoices'),
        icon: theme_path.url + '/resources/images/svg/icon-invoices.svg',
        url: '/bills'
    }
];
</script>

<template>
    <div class="account-sidebar" :class="{'is-enabled': mobileOpen}" @click.stop="mobileOpen = true">
        <button type="button" class="mobile-arrow">
            <img :src="`${theme_path.url}/resources/images/svg/icon-arrow-down.svg`" alt="">
        </button>
        <ul>
            <li v-for="(link, index) in links" :key="index">
                <RouterLink :to="link.url || '#'" @click.stop="mobileOpen = false">
                    <div class="account-sidebar__icon">
                        <img :src="link.icon" alt="" />
                    </div>
                    {{ link.label }}
                </RouterLink>
            </li>
            <li>
                <a href="/wp-json/custom/v1/logout">
                    <div class="account-sidebar__icon">
                        <img :src="theme_path.url + '/resources/images/svg/icon-logout.svg'" alt="" />
                    </div>
                    {{ __('disconnection') }}
                </a>
            </li>
        </ul>
    </div>
</template>